import { render, staticRenderFns } from "./top-banner.vue?vue&type=template&id=b6b3dcd0&scoped=true&"
import script from "./top-banner.vue?vue&type=script&lang=js&"
export * from "./top-banner.vue?vue&type=script&lang=js&"
import style0 from "./top-banner.vue?vue&type=style&index=0&id=b6b3dcd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b3dcd0",
  null
  
)

export default component.exports